import { Component, OnInit, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StaffPersonalComponent } from "../../user/staff-personal/staff-personal.component";
import { FinancialInfoComponent } from "../../user/financial-info/financial-info.component";
import { AddressDetailsComponent } from "../../user/address-details/address-details.component";
import { EmploymentInfoComponent } from '../../user/employment-info/employment-info.component';

@Component({
  selector: 'app-gst-add-staff',
  standalone: true,
  imports: [CommonModule, NgFor, FormsModule, StaffPersonalComponent, FinancialInfoComponent, AddressDetailsComponent, EmploymentInfoComponent],
  templateUrl: './gst-add-staff.component.html',
  styleUrl: './gst-add-staff.component.css'
})
export class GstAddStaffComponent implements OnInit {
  @Input() editingStaffId: number | null = null;
  activeTab = 0;
  isUserCreated = false;

  tabs = [
    { id: 'personal', label: 'Personal Information' },
    { id: 'financial', label: 'Financial Information' },
    { id: 'address', label: 'Address Details' },
    { id: 'employment', label: 'Employment Information' },
  ];

  ngOnInit(): void {
    this.activeTab = 0;
    if (!this.editingStaffId) {
      localStorage.removeItem('createdUser');
    }
    this.checkUserCreated();
  }

  selectTab(index: number) {
    if (index === 0 || this.isUserCreated) {
      this.activeTab = index;
      localStorage.setItem('gstAddStaffTab', index.toString());
    }
  }

  checkUserCreated() {
    const user = localStorage.getItem('createdUser');
    this.isUserCreated = !!user || !!this.editingStaffId;
  }
}
